import { Button, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import DealershipBottomSheet from './DealershipBottomSheet';
const useStyles = makeStyles({
  bottomSheetBtnContainer: {
    borderBottom: '1px solid #E4E7EC',
  },
  bottomSheetBtn: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.08px',
    color: 'rgba(98, 47, 238, 1)',
  },
});

const BottomSheetContainer = ({ data, isSheetOpen, toggleSheet, handleRemove }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-end"
      style={{ position: 'sticky', bottom: '5%', zIndex: 10 }}
    >
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.bottomSheetBtnContainer}
        >
          <Grid item>
            <DealershipBottomSheet
              isOpen={isSheetOpen}
              onClose={toggleSheet}
              data={data?.dealerships}
              handleRemove={handleRemove}
            />
          </Grid>
          <Grid item>
            <Button variant="text" onClick={toggleSheet} className={classes.bottomSheetBtn}>
              {`${data?.dealerships?.length} dealerships selected`}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BottomSheetContainer;
